import React, { lazy, Suspense, useState, useEffect } from "react";
import "../src/App.css";
import Header from "./components/Header";
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import { CookieSetting } from "cookiesetting-component";
const MaintenancePage = lazy(() => import("./components/MaintenancePage/MaintenancePage"));
 
const App = () => {
  const [maintenanceConfig, setMaintenanceConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showWidgets, setShowWidgets] = useState(false);
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const appVersion = appversion.version;

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWidgets(true); // Load AnalyticsAndWidgets after a delay
    }, 3000); // Adjust delay as needed (3000ms = 3 seconds)
    return () => clearTimeout(timer); // Cleanup timer
  }, []);

  useEffect(() => {
    const fetchMaintenanceConfig = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_MAINTENANCE_CONFIG_URL + '?_=' + Date.now()
        );
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        const currentDomain = window.location.hostname;
        
        const websiteKey = currentDomain.includes('angelai') ? 'angelai.com' : 
                         currentDomain.includes('swmc') ? 'swmc.com' : 
                         process.env.REACT_APP_WEBSITE_KEY || 'angelai.com';
        
        if (data.websites?.[websiteKey]) {
          setMaintenanceConfig(data.websites[websiteKey]);
          setIsMaintenanceMode(true);
        } else {
          throw new Error(`Configuration for ${websiteKey} not found`);
        }
      } catch (error) {
        console.error("Failed to load maintenance configuration:", error);
        setIsLoading(false);
      }
    };
    
    fetchMaintenanceConfig();
    
    // Optional: Periodically check for maintenance updates
    const intervalId = setInterval(fetchMaintenanceConfig, 300000); // 5 minutes
    
    return () => clearInterval(intervalId);
  }, []);

  // Always render maintenance page when config is loaded
  if (maintenanceConfig) {
    return (
      <div className="bodyContainer">
        <Suspense fallback={<div>Loading...</div>}>
          <MaintenancePage config={maintenanceConfig} />
        </Suspense>
      </div>
    );
  }

  // Show loading state while config is being fetched
  if (isLoading) {
    return (
      <div className="bodyContainer">
        <div>Loading...</div>
      </div>
    );
  }
};

export default App;